function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.009 512.009",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDDE64"
    },
    d: "M296.908,370.763h-79.81c-75.467,0-136.642-61.175-136.642-136.651V16.433 c0-9.075,7.353-16.428,16.428-16.428h320.238c9.075,0,16.437,7.353,16.437,16.428v217.679 C433.559,309.588,372.375,370.763,296.908,370.763"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M296.91,344.28h-79.81c-61.775,0-110.168-46.53-110.168-105.931c0-4.873,3.955-8.828,8.828-8.828 c4.882,0,8.828,3.955,8.828,8.828c0,49.496,40.642,88.276,92.513,88.276h79.81c51.871,0,92.504-38.78,92.504-88.276 c0-4.873,3.955-8.828,8.828-8.828c4.882,0,8.828,3.955,8.828,8.828C407.069,297.75,358.685,344.28,296.91,344.28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDDE64"
    },
    d: "M327.625,459.039H186.384v-18.264c0-9.419,7.627-17.046,17.046-17.046h107.149 c9.419,0,17.046,7.627,17.046,17.046V459.039z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M407.073,512.004H106.935c0-29.316,23.764-53.08,53.08-53.08h193.977 C383.31,458.924,407.073,482.688,407.073,512.004"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M470.169,70.625h-36.608v35.31h36.608c4.114,0,7.459,4.511,7.459,8.625v80.075 c0,21.513-11.467,41.755-29.917,52.833l-16.252,9.754c-3.381,19.8-10.911,38.171-21.839,54.087l6.471-3.69l49.796-29.881 c29.025-17.408,47.122-49.258,47.122-83.103V114.56C513.009,90.973,493.747,70.625,470.169,70.625"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M296.908,370.763h-79.81c-1.43,0-2.816-0.168-4.228-0.212v53.177h88.276v-53.177 C299.724,370.595,298.338,370.763,296.908,370.763"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M417.125,0.004H96.887c-9.075,0-16.437,7.353-16.437,16.428V52.97h353.103V16.433 C433.553,7.358,426.2,0.004,417.125,0.004"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M257.004,97.108l23.208,44.138h47.413l-35.31,44.138l8.828,52.966l-44.138-25.768l-44.138,25.768 l8.828-52.966l-35.31-44.138h47.413L257.004,97.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBA16"
    },
    d: "M43.84,70.625h36.608v35.31H43.84c-4.114,0-7.459,4.511-7.459,8.625v80.075 c0,21.513,11.467,41.755,29.917,52.833l16.252,9.754c3.381,19.8,10.911,38.171,21.839,54.087l-6.471-3.69l-49.796-29.881 C19.097,260.33,1,228.48,1,194.635V114.56C1,90.973,20.262,70.625,43.84,70.625"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.7002f86be19cb8f94dde0f0851c1037f.svg";
export { ForwardRef as ReactComponent };